import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 
 */
export class VerificationCodeController {
  constructor() {
      this.baseurl = 'VerificationCodeController.assx/';
  }

  /**
   * 检查验证码是否正确
   * code:String
   */
  CheckVerificationCode(code){
      return request.post(this.baseurl + 'CheckVerificationCode', Qs.stringify({ code:code }));
  }

  /**
   * 获取验证码base64字符串，可转图片
   * token:String
   */
  GetVerificationCodePicStr(token){
      return request.post(this.baseurl + 'GetVerificationCodePicStr', Qs.stringify({ token:token }));
  }
}